import { lazy } from 'react';
import commonPath from 'src/constants/urlPath/commonPath';
import type { RouteType } from 'src/hooks/useRouteElements';
import NewLayout from '../layouts/NewFeatures/MainLayout';
import urlPath from 'src/constants/urlPath/urlPath';

const DashboardPage = lazy(() => import('src/pages/CRM/Dashboard'));

const commonRoute: RouteType[] = [
  {
    path: commonPath.crm,
    Layout: NewLayout,
    Component: DashboardPage
  },
  {
    path: urlPath.home.location,
    redirect: commonPath.crm
  }
];

export default commonRoute;
